/**
 * Validación y ajuste de cantidades según metacampos MOQ / incremento de variante.
 */
(function () {
  'use strict';

  function getRules(input) {
    return {
      active: input.dataset.moqActive === 'true',
      min: parseInt(input.dataset.moqMin, 10) || 1,
      step: parseInt(input.dataset.moqStep, 10) || 1
    };
  }

  function snapQuantity(rawQty, rules) {
    let qty = parseInt(rawQty, 10);

    if (!rules.active) {
      return Math.max(1, isNaN(qty) ? 1 : qty);
    }

    const step = rules.step > 1 ? rules.step : 1;

    if (isNaN(qty) || qty < rules.min) {
      return rules.min;
    }

    const remainder = (qty - rules.min) % step;
    if (remainder !== 0) {
      qty = qty - remainder + step;
    }

    return qty;
  }

  function isValidQuantity(rawQty, rules) {
    const qty = parseInt(rawQty, 10);
    if (isNaN(qty) || qty < 1) return false;
    if (!rules.active) return true;
    if (qty < rules.min) return false;
    const step = rules.step > 1 ? rules.step : 1;
    return (qty - rules.min) % step === 0;
  }

  function formatInvalidMessage(rules) {
    const strings = (window.theme && window.theme.moqStrings) || {};
    const template = rules.step > 1
      ? (strings.invalidFull || 'La cantidad debe ser al menos {{ minimum }} unidades, en múltiplos de {{ increment }}.')
      : (strings.invalidMin || 'La cantidad debe ser al menos {{ minimum }} unidades.');
    return template
      .replace(/\{\{\s*minimum\s*\}\}/g, rules.min)
      .replace(/\{\{\s*increment\s*\}\}/g, rules.step);
  }

  function showProductError(form, message) {
    const wrapper =
      form.closest('product-form')?.querySelector('.form-notification.error') ||
      form.querySelector('.form-notification.error');

    if (!wrapper) return;
    wrapper.style.display = 'block';
    wrapper.textContent = message;
  }

  function clearProductError(form) {
    const wrapper =
      form.closest('product-form')?.querySelector('.form-notification.error') ||
      form.querySelector('.form-notification.error');

    if (!wrapper) return;
    wrapper.style.display = 'none';
    wrapper.textContent = '';
  }

  function handleInputSnap(input) {
    const rules = getRules(input);
    if (!rules.active) return;

    const snapped = snapQuantity(input.value, rules);
    if (parseInt(input.value, 10) !== snapped) {
      input.value = snapped;
    }
  }

  function initInput(input) {
    if (input.dataset.moqInit === 'true') return;
    input.dataset.moqInit = 'true';
    handleInputSnap(input);
  }

  function initAllInputs(root) {
    (root || document).querySelectorAll('.qty[data-moq-active="true"]').forEach(initInput);
  }

  document.addEventListener(
    'change',
    function (event) {
      if (!event.target.matches('.qty[data-moq-active="true"]')) return;
      handleInputSnap(event.target);
    },
    true
  );

  document.addEventListener(
    'blur',
    function (event) {
      if (!event.target.matches('.qty[data-moq-active="true"]')) return;
      handleInputSnap(event.target);
    },
    true
  );

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form.matches('[data-type="add-to-cart-form"]')) return;

    const qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) return;

    const rules = getRules(qtyInput);
    handleInputSnap(qtyInput);

    if (!isValidQuantity(qtyInput.value, rules)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showProductError(form, formatInvalidMessage(rules));
      return;
    }

    clearProductError(form);
  }, true);

  document.addEventListener('product:variant-change', function () {
    requestAnimationFrame(function () {
      initAllInputs();
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    initAllInputs();
  });

  document.addEventListener('line-item:change:end', function () {
    requestAnimationFrame(function () {
      initAllInputs();
    });
  });

  document.addEventListener('cart:refresh', function () {
    requestAnimationFrame(function () {
      initAllInputs();
    });
  });
})();
